import React from "react"
import { useTranslation } from "react-i18next"
import type { ColumnsType } from "antd/es/table"
import { OwnerTable } from "../../molecules"
import styled from "styled-components"
import { theme } from "@project/shared"

export const TableWrapper = styled.div`
  .width-min {
    min-width: 150px;
  }
  .width-min-100 {
    min-width: 100px;
  }
  .no-certificate-row {
    background-color: ${theme.lightPink} !important;
  }
`
interface IProps {
  loading: boolean
  columns: ColumnsType<any>
  dataSource: any | []
  currentPage: number
  total: number | undefined
  pageSize: number
  handlePaginationChange: (val: number) => void
}

export const UsersWhoNeedMonitoringList: React.FC<IProps> = (props) => {
  const { t } = useTranslation()

  return (
    <TableWrapper>
      <OwnerTable
        {...props}
        scroll={{ x: "max-content" }}
        bordered
        extra={
          <div className={"table__top__extra"}>
            <div className={"certi"}>
              {t("Children who do not have a registered recipient certificate")}
            </div>
          </div>
        }
        rowClassName={(row) => {
          if (!row?.CertificateId) {
            return "no-certificate-row"
          }
        }}
      />
    </TableWrapper>
  )
}
